import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-turns-form-schedule',
  templateUrl: './turns-form-schedule.component.html',
  styleUrls: ['./turns-form-schedule.component.scss']
})
export class TurnsFormScheduleComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
